import { DtoRequestOvertimesPostReq } from "./abst/DtoRequestOvertimesPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestOvertimesPostReqImple extends DtoRequestOvertimesPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
